import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";

const sentryDsn = process.env.REACT_APP_SENTRY_URL;

if (process.env.REACT_APP_ENV !== "dev" && sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.REACT_APP_ENV || process.env.NODE_ENV,
    release: process.env.REACT_APP_IMAGE_TAG,
    tracesSampleRate: 0.2,
  });
  Sentry.setTag("app", "ui");
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
